import { configureStore } from '@reduxjs/toolkit';
import { Provider } from 'react-redux';

import { NODE_ENV } from '../constants/appConstants';
import { appRefsReducer } from './appRefsSlice';
import { appReducer } from './appSlice';

export const store = configureStore({
  reducer: {
    app: appReducer,
    appRefs: appRefsReducer,
  },
  middleware: getDefaultMiddleware =>
    getDefaultMiddleware({ immutableCheck: false, serializableCheck: false }),
  devTools: NODE_ENV === 'development',
});

export type AppDispatch = typeof store.dispatch;
export type AppGetState = typeof store.getState;

// Development access to store
if (NODE_ENV === 'development') {
  (window as any).store = store;
}

export const AppStoreProvider = (props: Readonly<{ children: React.ReactNode }>) => (
  <Provider store={store} {...props} />
);
